module.exports = __webpack_public_path__ + "img/BAU_Partners_6.96eedd7e.jpg";